export default __webpack_public_path__ + "static/media/popcorn.4aa58256.gif";